import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ContractSearch.css"; // Use the same CSS styling
import api from "../pages/chat/api";
const ContractSearch = ({ onDocumentSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [documents, setDocuments] = useState([]);
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [contractKey, setContractKey] = useState("");
  const [contractUrl, setContractUrl] = useState("");
  const [documentType, setdocumentType] = useState("");

  

  const fetchDocuments = async (query = "") => {
    // if (!token) {
    //   console.warn("No token provided. Please login.");
    //   return;
    // }
    setLoading(true);
    setError(null);

    const url = query
    ? `api/v1/copilot/all-docs/?search=${query}`
    : `api/v1/copilot/all-docs/`;

  try {
    const response = await api.get(url);

      // Extract the documents array from the response
      const { documents = [] } = response.data;

      // Map each document to include the needed fields
      const filteredDocuments = documents.map((doc) => ({
        ...doc,
        url: doc.url,
        type: doc.document_type,
      }));

      setDocuments(filteredDocuments);
    } catch (error) {
      console.error("Error fetching documents:", error);
      setDocuments([]);
      setError("Failed to fetch documents. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDocumentSelect = (doc) => {
    setSelectedDocuments((prevSelected) => [...prevSelected, doc]);
    setContractKey(doc.key);
    setContractUrl(doc.url);
    setdocumentType(doc.document_type);

    if (onDocumentSelect) {
      onDocumentSelect(doc); // Pass the document to the parent if needed
    }

    setSearchQuery("");
    setShowDropdown(false);
  };

  const handleRemoveDocument = (doc) => {
    setSelectedDocuments((prevSelected) =>
      prevSelected.filter((selectedDoc) => selectedDoc.key !== doc.key)
    );
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setShowDropdown(true);
    fetchDocuments(query);
  };

  const handleInputBlur = () => {
    // Delay hiding the dropdown to allow clicks on items
    setTimeout(() => {
      setShowDropdown(false);
    }, 200);
  };

  const handleDropdownMouseDown = (e) => {
    // Prevent the blur event when clicking inside the dropdown
    e.preventDefault();
  };

  // Compute filtered documents based on the search query
  const filteredDocs = documents.filter((doc) =>
    doc.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="contract-search-container">
      {/* Show search input only if no documents are selected */}
      {selectedDocuments.length === 0 && (
        <>
          <img src="searchAICP.svg" alt="Search Icon" className="search-icon" />
          <input
            type="text"
            placeholder="Search Documents"
            className="search-input"
            value={searchQuery}
            onChange={handleSearchChange}
            onFocus={() => {
              setShowDropdown(true);
              if (!searchQuery) fetchDocuments("");
            }}
            onBlur={handleInputBlur}
          />
        </>
      )}

      {/* Selected Documents */}
      <div className="selected-docs-container">
        {selectedDocuments.map((doc, index) => (
          <div
            key={index}
            className="selected-doc-button selected-doc-button-style"
            role="option"
          >
            <span className="truncate">{doc.name}</span>
            <button
              onClick={() => handleRemoveDocument(doc)}
              className="remove-doc-button"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      {/* Dropdown */}
      {showDropdown && (
        <div className="dropdown-wrapper">
          <div
            className="dropdown-container"
            role="listbox"
            onMouseDown={handleDropdownMouseDown}
          >
            {/* Arrow at the bottom */}
            <div className="dropdown-arrow-container">
              <div className="dropdown-arrow"></div>
            </div>

            {/* Dropdown header */}
            <div className="dropdown-header-wrapper">
              <h1 className="dropdown-header">Select Document</h1>
            </div>

            {/* Scrollable content */}
            <div className="dropdown-scroll-content">
              {loading ? (
                <div className="loading-text">Loading...</div>
              ) : error ? (
                <div className="error-text">{error}</div>
              ) : filteredDocs.length > 0 ? (
                filteredDocs.map((doc) => (
                  <button
                    key={doc.key}
                    className="dropdown-item-button"
                    onClick={() => handleDocumentSelect(doc)}
                  >
                    <img
                      src="/ai-object-document-icon.svg"
                      alt="document icon"
                    />
                    <span className="truncate">{doc.name}</span>
                  </button>
                ))
              ) : (
                <div className="no-contracts-text">No Documents found</div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContractSearch;
